import { CellContext } from '@tanstack/react-table';
import { Skeleton } from '@round/creatorbase-ui';
import { formatNumber, formatPercentage } from 'Modules/Plans/CreatorSearch/utils/creatorSearchUtils';
import { ExploreAccount } from '../../../../types';
import { CreatorAccountRow, getMeta } from '../../helpers';
import styles from './StatCells.module.css';

type Props = CellContext<CreatorAccountRow, unknown>;

/**
 * A cell for one of the stats Creator Explore has for the row's own account, rather than the creator's
 * across all of theirs. A row Explore has no account for reads as a stat without a value.
 */
const createStatCell = (getValue: (metrics: ExploreAccount['metrics'] | undefined) => string) =>
    function StatCell({ row: { original }, table }: Props) {
        const { isExploreLoading } = getMeta(table);

        if (isExploreLoading) {
            return <Skeleton className={styles.skeleton} />;
        }

        return getValue(original.exploreAccount?.metrics);
    };

export const FollowersCell = createStatCell((metrics) => formatNumber(metrics?.total_follower_count));

export const AvgViewsCell = createStatCell((metrics) => formatNumber(metrics?.avg_video_views_per_post));

export const EngagementRateCell = createStatCell((metrics) => formatPercentage(metrics?.avg_engagement_rate));
